import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { UserEventFollowSite } from '../model/UserEventFollowSite';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { PostService } from '../../shared/services/post.service';
import { PostSeo } from '../../shared/models/postSeo';
import { CustomEncoder } from '../../shared/services/url.service';

@Injectable()
export class EventFollowsService {
  private eventFollowApiURL = APP_SETTINGS.EventFollowApiUrl;

  constructor(
    private executeService: ExecuteService,
    private postService: PostService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetEventFollowsByEmail(email: string): Observable<UserEventFollowSite[]> {
    const url: string = this.eventFollowApiURL;
    const params = new HttpParams({ encoder: new CustomEncoder() }).set('email', email);

    return this.executeService.ExecuteWithToken('get', url, params)
      .pipe(
        mergeMap((eFollows: any[]) => Observable.forkJoin(
          eFollows.map(
            ef => this.postService.GetById(ef.postId, "en-US")
              .pipe(map((post: PostSeo) => this.mapEventFollowModels(ef, post)))
        ))),
        catchError(this.errorHandler.handleError('EventFollowsService_GetEventFollowsByEmail email', [], true))
      );
  }

  public Delete(email: string) {
    const url = this.eventFollowApiURL;
    const body = { email: email };

    return this.executeService.ExecuteWithToken('delete', url, null, body)
      .pipe(
        catchError(this.errorHandler.handleAndThrowError('EventFollows_Delete ' + email, null, true))
      );
  }

  private mapEventFollowModels(ef: any, post: PostSeo): UserEventFollowSite {
    let response: UserEventFollowSite;
    if (ef != null) {
      response = {
        EventFollowId: ef.id,
        PostId: ef.postId,
        PostTitle: post.Title,
        Email: ef.email
      };
    }
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/eventFollows.service.ts